/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-component-legacy/upgraded-url/template/trackingTemplate.pug';
import ViewModel from '@bingads-webui-component-legacy/upgraded-url/viewmodel/trackingTemplate';
import config from '@bingads-webui-component-legacy/config/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var permissions = config.get('Permissions') || ({});
var TrackingTemplate = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    _.defaults(this.options, {
      template: tmpl,
      editMode: true,
      errorMessages: '',
      isValid: true,
      placeholderEnabled: false,
      placeholders: {},
      isForVNext: false,
      templateExampleEnabled: true
    });
    this.ko_model = new ViewModel(this.options);
    this.ko_model.trackingTemplate.subscribe(function (value) {
      this.trigger('templateChanged', value);
    }, this);
  },
  render: function () {
    this.$el.html($(tmpl({
      i18n: i18n,
      trackingTemplatePlaceholdertype: this.options.placeholderEnabled ? _.result(this.options.placeholders, 'TrackingUrlTemplate') || i18n.get('UpgradedUrl_Placeholder_TrackingUrlTemplate') : '',
      readOnly: this.options.readOnly
    })));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  remove: function () {
    ko.cleanNode(this.el);
    return this;
  },
  setEditMode: function (isEdit) {
    this.ko_model.editMode(isEdit);
  },
  setTrackingTemplate: function (trackingTemplate) {
    this.ko_model.trackingTemplate(trackingTemplate);
  },
  getTrackingTemplate: function () {
    var trackingTemplate = this.ko_model.trackingTemplate() || '';
    return trackingTemplate.trim();
  },
  setErrors: function (errors) {
    this.ko_model.errorMessages(errors);
  },
  isValid: function () {
    return !this.ko_model.errorMessages().length;
  }
});
export default TrackingTemplate;

